import React, { useState, useEffect } from 'react';
import './ColorPicker.css';

export default function ColorPicker({ initialHex, onSave }) {
  // We keep the hex without the '#' internally for consistency, 
  // but add it when interacting with native color input.
  const [hex, setHex] = useState(initialHex || '000000');

  useEffect(() => {
    setHex(initialHex || '000000');
  }, [initialHex]);

  const handleChange = (newHex) => {
    let clean = newHex.replace('#', '');
    setHex(clean);
  };

  const handleBlur = () => {
    // Only save if it actually changed
    if (hex !== initialHex) {
      onSave(hex);
    }
  };

  return (
    <div className="custom-color-picker">
      <div className="ccp-swatch-wrap">
        <input 
          type="color" 
          value={`#${hex}`} 
          onChange={(e) => handleChange(e.target.value)}
          onBlur={handleBlur}
          className="ccp-input-color"
          title="Pick a color"
        />
      </div>
      <div className="ccp-text-wrap">
        <span className="ccp-hash">#</span>
        <input 
          type="text" 
          value={hex}
          onChange={(e) => handleChange(e.target.value)}
          onBlur={handleBlur}
          className="ccp-input-text"
          maxLength={6}
        />
      </div>
    </div>
  );
}
